<template>
  <div id="container">
    <div class="seller_full">
      <div class="seller_box full_layout" v-if="sellerInfo!=null">
        <div class="seller_img_box">
          <div class="seller_img">
            <img :src="sellerInfo.StoreLogo" />
          </div>
        </div>
        <div class="seller_title_box">
          <h2>{{sellerInfo.StoreName}}</h2>
          <div>
            <div class="sold"><span>{{sellerInfo.FollowerCount}}</span>{{$t('base.followers')}}</div>
            <div class="sold">
              <span>{{sellerInfo.CommoditySellCount}}</span>{{sellerInfo.CommoditySellCount!=1?$t('base.itemsSelling'):$t('base.itemSelling')}}
            </div>
            <div class="sold">
              <span>{{sellerInfo.CommoditySoldCount}}</span>{{sellerInfo.CommoditySoldCount != 1?$t('base.items'):$t('base.item')}} {{$t('base.monthSold')}}
            </div>
          </div>
          <div class="seller_save_box">
            <div class="attention">
              <div class="seller_save" :class="sellerInfo.IsAttention?'on':''" @click="setAttention">
                {{sellerInfo.IsAttention?$t('base.saved'):$t('base.shop')}}</div>
            </div>
            <div class="attention">
              <div class="seller_save contact_box" @click="allContact(sellerInfo.Id)">
                {{$t('base.contact')}}</div>
            </div>
            <div class="attention">
              <div class="seller_save seller_block" :class="sellerInfo.IsInBlacklist?'on':''" @click="setBlock">
                {{sellerInfo.IsInBlacklist?$t('base.unbolck'):$t('base.block')}}</div>
            </div>
            <!-- IsInBlacklist -->
          </div>
        </div>
        <div class="seller_about_box">
          <div class="about_box">
            <h4>{{$t('base.aboutUs')}}</h4>
            <p class="about_p" :class="sellerInfo.AboutStore == null?'color_aoao':''">
              {{sellerInfo.AboutStore == null?$t('base.aboutStore'):sellerInfo.AboutStore}}</p>
          </div>
          <div class="about_box">
            <h4 class="Feedback_m">{{$t('base.feedbackRatings')}}</h4>
            <div class="feedback">
              <span @click="goto('feedback',1)"><em class="praise">{{sellerInfo.BuyFavorableCount+sellerInfo.SellFavorableCount}}</em>{{$t('base.positive')}}</span>
              <span @click="goto('feedback',2)"><em>{{sellerInfo.BuyNegativeCount+sellerInfo.SellNegativeCount}}</em>{{$t('base.negative')}}</span>
              <!-- <span><em class="praise">{{sellerInfo.BuyFavorableCount}}</em>Positive</span>
              <span><em>{{sellerInfo.BuyNegativeCount}}</em>Negative</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="all_item full_layout">
      <div class="flex_layout_between">
        <h3>{{$t('base.allItems')}}</h3>
        <div class="flex_input">
          <el-input ref="ifSellingCounts" :placeholder="$t('base.searchItem')" v-model="searchKey" class="input-with-select" @change="GetStoresGoods">
          </el-input>
          <el-button slot="append" @click="GetStoresGoods" icon="el-icon-search"></el-button>
        </div>
      </div>
      <div class="flex_layout_between">
        <div class="seller_tab">
          <span class="" v-if="searchKey!=''" :class="isSort == 0 ? 'on' : ''" @click="SellerSort(0)">{{$t('base.bestMatch')}}</span>
          <el-divider v-if="searchKey!=''" direction="vertical"></el-divider>
          <span class="" :class="isSort==1?'on':''" @click="SellerSort(1)">{{Status=='1'?$t('enum.endingSoonest'):$t('enum.endingRecently')}}</span>
          <el-divider direction="vertical"></el-divider>
          <span class="sort_price" :class="isSort==2?'on':''" @click="SellerSort(2)">
            {{$t('base.price')}}
            <em class="up_arr" :class="isPrice?'up':''"></em>
            <em class="up_down" :class="!isPrice&&isPrice!=null?'up':''"></em>
          </span>
          <el-divider direction="vertical"></el-divider>
          <span class="" :class="isSort==3?'on':''" @click="SellerSort(3)">{{$t('base.newly')}}</span>
          <el-divider v-if='isAuction' direction="vertical"></el-divider>
          <span v-if='isAuction' class="" :class="isSort == 4 ? 'on' : ''" @click="SellerSort(4)">{{$t('base.mostBids')}}</span>
        </div>
        <div class="seller_select">
          <el-select class="select_seller all_listings" v-model="listings" :placeholder="$t('enum.allListings')" @change="getSelect('listings')">
            <el-option v-for="(item,index) in all_listings" :key="item.index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select class="select_seller" v-model="Status" :placeholder="$t('base.status')" @change="getSelect('Status')">
            <el-option v-for="(item,index) in all_Status" :key="item.index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <!--  <el-select class="select_seller" v-model="Graded" placeholder="Graded">
            <el-option v-for="(item,index) in all_Graded" :key="item.index" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
        </div>
      </div>
    </div>
    <!--  :loading="loading" -->
    <el-skeleton :count="12" animated class="full_layout skull" :loading="loading">
      <template slot="template">
        <list-skeleton />
      </template>
      <template>
        <goods-list class="full_layout full_list" :list="list" type="seller" />
      </template>
    </el-skeleton>
    <!--  <goods-list class="full_layout full_list" :list="list" type="seller" /> -->
    <list-pagination class="full_layout" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!ifData" />
    <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
    <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else />
  </div>
</template>
<script>
import NOTN from "@/components/notnull.vue";
import FZF from "@/components/404.vue";
import { getInfo, GoYunXin, setMeta } from "@/api/public";
import GoodsList from "@/components/list/goods";
import ListPagination from '@/components/listpagination'
import ListSkeleton from "@/components/skeleton.vue";
import qs from 'qs'
export default {
  name: 'index',
  components: { GoodsList, ListPagination, NOTN, FZF, ListSkeleton },
  data() {
    return {
      sellerInfo: null,
      userInfo: null,
      resultTpye: '',
      sort: 'EffectiveTimeStamp',
      sortType: 'asc',
      ifData: false,
      list: {},
      ps: 60, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      isSort: 1,
      isPrice: null,
      isAuction: true, // 是否拍卖
      searchKey: '',
      listings: "0",
      Status: "1",
      isTabSold: {
        'selling': 1,
        'sold': 3
      },
      // Graded: "1",
      all_Sort: this.$enumInfo.searchSort,
      all_listings: this.$enumInfo.listings,
      all_Status: this.$enumInfo.status,
      // all_Graded: ex.cardhobby.graded,
      //auction拍卖：2、buy it now一口价：1->ByWay accept offers可议价：1->Bargain Status是selling出售中1、sold出售的-2
      //{ "Key": "ByWay", "Value": "" }, { "Key": "Bargain", "Value": "" },
      buway: [],
      CategoryKeys: [{ "Key": "Status", "Value": 1 }],
      nofind: false,
      loading: false,
    }
  },
  mounted() {},
  created() {
    let that = this
    this.userInfo = getInfo();
    this.sort = this.all_Sort[0]['val'];
    this.sortType = this.all_Sort[0]['sortType'];
    this.GetStoresList(1);
  },
  methods: {
    allContact(val) {
      if (this.userInfo) {
        GoYunXin(this.userInfo, val)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    // 获取店铺详细 0:不刷新商品列表，1:刷新商品列表
    GetStoresList(val) {
      let that = this
      let data = { 'Id': this.$route.params.id, 'MemberId': '' }
      if (that.userInfo != null) {
        data.MemberId = that.userInfo.MappingUserId
      }
      this.$get(this.$interface.GetStoreDetail, data).then(res => {
        //console.log(res)
        if (res.result != 0) {
          that.sellerInfo = res.data
          that.TotalCount = that.sellerInfo.CommoditySellCount
          document.title = that.sellerInfo.StoreName;

          setMeta('apple-itunes-app', ', app-argument=cardOverseasApp://StoreId:' + that.sellerInfo.Id, 1)
          that.CategoryKeys.push({ "Key": "CreateUser", "Value": that.sellerInfo.Id })
          if(that.userInfo != null){
          that.getInBlacklist()
          }
          if (val == 1) {
            that.GetStoresGoods()
          }
        }
      })
    },
    getInBlacklist(){
      let that = this
      let data = { 'SellUserID': this.$route.params.id, 'memberid': that.userInfo.MappingUserId,operator_id:that.userInfo.MappingUserId,token:that.userInfo.ChineseToken }
      that.$get(this.$interface.AttentionDetail, data).then(res => {
        if(res.result){
          that.sellerInfo.IsInBlacklist=res.data.IsInBlacklist
        }
      })
    },
    // 获取店铺商品列表
    GetStoresGoods() {
      let that = this;
      that.loading = true
      let Categorylist = []
      Categorylist = [...that.CategoryKeys, ...that.buway]
      let SeachJson = JSON.stringify(Categorylist);
      if (that.searchKey != '') {
        that.isSort = 0;
        that.sort = '';
        that.sortType = '';
      }
      let data = { userId: '', pageIndex: that.pi, pageSize: that.ps, searchKey: that.searchKey, searchJson: SeachJson, sort: that.sort, sortType: that.sortType }
      if (that.userInfo != null) {
        data.userId = that.userInfo.MappingUserId
      }
      console.log('获取店铺商品列表',data)
      this.$post(this.$interface.SearchCommodityPost, data).then(res => {
        // console.log(res)
        if (res.result != 0) {
          var data = res.data;
          that.pi = parseInt(data.PageIndex)
          that.TotalCount = parseInt(data.TotalCount)
          that.list = data.PagedMarketItemList;
          if (that.list.length == 0) {
            this.ifData = true;
          } else {
            this.ifData = false
          }
        } else {
          this.ifData = true
        }
        that.resultTpye = res.result
        that.loading = false
      })
      //console.log(data,that.sellerInfo.Id)
    },
    // 判断是否关注商家
    setAttention() {
      let that = this;
      if (that.userInfo != null) {
        let data = { 'selluserid': that.sellerInfo.Id, 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
        this.$post(that.$interface.SetAttention, qs.stringify(data)).then(res => {
          if (res.result != 0) {
            that.GetStoresList(0)
          }
        })
      } else {
        window.location = '/#/login'
      }
    },
    //拉黑/解除 卖家
    setBlock() {
      let that = this
      if (that.userInfo != null) {
        const isblock = function() {
          let data = { TargetId: that.sellerInfo.Id, Type: that.sellerInfo.IsInBlacklist ? 2 : 1, Memberid: that.userInfo.MappingUserId, Token: that.userInfo.ChineseToken, Operator_id: that.userInfo.MappingUserId }
          that.$post(that.$interface.OperateBlacklist, data).then(res => {
            if (res.result) {
              let msg="Blocked successfully"
              if(that.sellerInfo.IsInBlacklist){
                msg="Unblocked successfully"
              }
              that.$message({
                  type: 'warning',
                  duration: 1000,
                  message: msg
                });
              that.sellerInfo.IsInBlacklist = !that.sellerInfo.IsInBlacklist
            } else {
              that.$message({
                  type: 'error',
                  duration: 1000,
                  message: res.msg
                });
            }
          })
        }
        if (that.sellerInfo.IsInBlacklist) {
          isblock()
        } else {
          //that.sellerInfo.StoreName
          //
          this.$confirm('<div style="text-align: center;">If you block him, he can not chat with you.</div>', this.$t('title.bolckname',{name:that.sellerInfo.StoreName}), {
            lockScroll: false,
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('base.block'),
            cancelButtonText: this.$t('base.cancel')
          }).then(() => {

            isblock()
          }).catch(() => {});
        }
      } else {
        window.location = '/#/login'
      }
    },
    // select 筛选
    getSelect(val) {
      let that = this;
      that.buway = [];
      switch (val) {
        case 'listings':
          if (that.listings == 2 || that.listings == 1) {
            if (that.listings == 2) {
              that.isAuction = true
            } else {
              that.isAuction = false
            }
            that.buway.push({ "Key": "ByWay", "Value": that.listings })
            if(that.listings==1){
              that.buway.push({ "Key": "Bargain", "Value": 0 })
            }
          } else if (that.listings == 3) {

            that.buway.push({ "Key": "Bargain", "Value": '1' })
          } else if (that.listings == 0) {

            that.isAuction = true
            that.buway = []
          }
          break;
        case 'Status':
          if (that.Status == 1 || that.Status == 0) {

            that.SellerSort(that.isTabSold.selling, 1)
            that.CategoryKeys.map(res => {
              if (res.Key == 'Status') {
                res.Value = 1
              }
            })
          } else {

            that.SellerSort(that.isTabSold.sold, 1)
            that.CategoryKeys.map(res => {
              if (res.Key == 'Status') {
                res.Value = '-2'
              }
            })
          }
          break;
        case 'Graded':
          let radiolist = that.checkList;
          let radioObj = '';
          radiolist.map(res => {
            if (res.Property.ControlName == 'Graded') {
              radioObj = res.PropertyKeyValues
            }
          })
          if (that.Graded == 0) {
            that.radiosportslist.Graded = {}
          } else if (that.Graded == 1) {
            that.radiosportslist.Graded = radioObj[1]
          } else if (that.Graded == 2) {
            that.radiosportslist.Graded = radioObj[0]
          }
          break;

      }
      that.GetStoresGoods()
    },
    // tab 排序
    SellerSort(val, type) {
      let that = this;
      that.isSort = val;
      if (val == 0) {} {
        that.sort = '';
        that.sortType = '';
      }

      if (that.Status == '1') {
        that.isTabSold.selling = val
      } else {
        that.isTabSold.sold = val
      }
      if (val == 1) {
        that.sort = that.all_Sort[0]['val'];
        if (that.Status == '1') {
          that.sortType = that.all_Sort[0]['sortType'];
        } else {
          that.sortType = 'DESC'
        }
      }
      if (val == 3) {
        that.sort = that.all_Sort[3]['val']
        that.sortType = that.all_Sort[3]['sortType']
      }
      if (val == 2) {
        that.sort = that.all_Sort[1]['val'];
        that.isPrice = !that.isPrice;
        if (that.isPrice) {
          that.sortType = that.all_Sort[1]['sortType'];
        } else {
          that.sortType = that.all_Sort[2]['sortType'];
        }

      } else {
        that.isPrice = null;
      }
      if (val == 4) {
        let isByWay = 0
        that.sort = that.all_Sort[4]['val'];
        that.sortType = that.all_Sort[4]['sortType'];
        that.buway = []
        that.buway.push({ "Key": "ByWay", "Value": '2' })
        that.listings = '2'
      }
      if (type != 1) {
        this.GetStoresGoods();
      }
      //this.GetStoresGoods();
    },

    // 页面跳转 val feedback
    goto(val, type) {
      var url = "";

      if (this.userInfo) {
        if (val == 'feedback') {
          url = '/feedback/seller?id=' + this.sellerInfo.Id + '&type=' + type
        }
        this.$router.push({
          path: url
        })
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.GetStoresGoods();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.GetStoresGoods();
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/seller.css";

.feedback span {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/pages/seller/index.vue